<template>
  <section>
    <div v-if="!isMobile">
      <app-nav-app/>
      <div
        class="columns is-paddingless is-fullwidth"
        v-if="dataLoad"
      >
        <div class="column is-paddingless is-9">
          <div class="column is-paddingless is-11 goToLeft goToRight">
            <app-info-opp :dataInfoOpp="dataInfoOpp"/>
            <filtre-opp
              :produits="produitOpportunite"/>
            <app-carto-general
              v-if="showGenralCarto"
              :produits="produitOpportunite"
              :adresseClient="adressePuceNoireClient"/>
            <app-panneaux-lc
              v-if="produitOpportunite.panneauxLc.length
                && (filterProduit.length === 0 || filterProduit.includes(0))"
              :detailPanneauxLc="produitOpportunite.panneauxLc"
              :adresseFaceLc="adressePuceNoireFaceLc"/>
            <app-reseaux-tempo
              v-if="produitOpportunite.reseauxTempo.length
                && (filterProduit.length === 0 || filterProduit.includes(1))"
              :detailReseauxTempo="produitOpportunite.reseauxTempo"
              :adresseReseauxTempo="adressePuceNoireReseauxTempo"
              :idOpportunite="idOpportunite"
              :showDimension="showDimension"/>
            <app-reseaux-lc
              v-if="produitOpportunite.reseauxLc.length
                && (filterProduit.length === 0 || filterProduit.includes(2))"
              :detailReseauxLc='produitOpportunite.reseauxLc'
              :adresseReseauxLc="adressePuceNoireReseauxLc"/>
            <app-panneaux-numeriques
              v-if="produitOpportunite.panneauxNumeriques.length
                && (filterProduit.length === 0 || filterProduit.includes(3))"
              :detailPanneauxNumerique="produitOpportunite.panneauxNumeriques"
              :adresseVenteNumerique="adressePuceNoireVenteNumerique"/>
            <app-reseaux-numeriques
              v-if="produitOpportunite.reseauxNumeriques.length
                && (filterProduit.length === 0 || filterProduit.includes(4))"
              :detailReseauxNumerique="produitOpportunite.reseauxNumeriques"
              :adresseReseauxNumeriques="adressePuceNoireReseauxNumeriques"/>
            <app-reseaux-personnalise
              v-if="produitOpportunite.reseauxPersonnalise.length
                && (filterProduit.length === 0 || filterProduit.includes(5))"
              :detailReseauxPersonnalise="produitOpportunite.reseauxPersonnalise"/>
          </div>
        </div>
        <div class="column is-paddingless is-3 is-offset-9 right">
          <app-info-commercial :dataInfoCommercial="dataInfoCommercial"/>
          <app-bloc-selection
            :date="detailOpportunite.dateValidite"
            :email="detailOpportunite.commercial.email"
            :commercial="commercialName"
            :client="clientName"
            :themeCampagne="themeCampagne"/>
        </div>
      </div>
    </div>
    <div v-if="isMobile && dataLoad">
      <app-mobile-nav-app/>
      <app-mobile-info-commercial
        v-if="showContact"
        :dataInfoCommercial="dataInfoCommercial"
        :client="clientName"/>
      <app-mobile-bloc-selection
        :date="detailOpportunite.dateValidite"
        :email="detailOpportunite.commercial.email"
        :commercial="commercialName"
        :client="clientName"
        :themeCampagne="themeCampagne"
      />
      <div class="column is-paddingless leftVert rightVert" v-if="dataLoad">
        <app-mobile-info-opp :dataInfoOpp="dataInfoOpp"/>
        <app-mobile-panneaux-lc
          v-if="produitOpportunite.panneauxLc.length"
          :detailPanneauxLc="produitOpportunite.panneauxLc"
          :adresseFaceLc="adressePuceNoireFaceLc"/>
        <app-mobile-reseaux-tempo
          v-if="produitOpportunite.reseauxTempo.length"
          :detailReseauxTempo="produitOpportunite.reseauxTempo"
          :adresseReseauxTempo="adressePuceNoireReseauxTempo"
          :idOpportunite="idOpportunite"/>
        <app-mobile-reseaux-lc
          v-if="produitOpportunite.reseauxLc.length"
          :detailReseauxLc='produitOpportunite.reseauxLc'
          :adresseReseauxLc="adressePuceNoireReseauxLc"/>
        <app-mobile-panneaux-numeriques
          v-if="produitOpportunite.panneauxNumeriques.length"
          :detailPanneauxNumerique="produitOpportunite.panneauxNumeriques"
          :adresseVenteNumerique="adressePuceNoireVenteNumerique"/>
        <app-mobile-reseaux-numeriques
          v-if="produitOpportunite.reseauxNumeriques.length"
          :detailReseauxNumerique="produitOpportunite.reseauxNumeriques"
          :adresseReseauxNumeriques="adressePuceNoireReseauxNumeriques"/>
        <app-mobile-reseaux-personnalise
          v-if="produitOpportunite.reseauxPersonnalise.length"
          :detailReseauxPersonnalise="produitOpportunite.reseauxPersonnalise"/>
        <div class="footerM"></div>
      </div>
    </div>
    <br>
    <br>
  </section>
</template>

<script>
import gestionErreur from '@/services/general/gestionErreur';
import getOpportunite from '@/services/opportunite/getOpportunite';
import getMobile from '@/services/opportunite/divice';
import cloneDeep from 'lodash/cloneDeep';
import navApp from './composants/navApp';
import infoOpp from './composants/infoOpp';
import infoCommercial from './composants/infoCommercial';
import blocSelection from './composants/blocSelection';
import cartoGeneral from './propositions/cartoGeneral/index';
import panneauxLc from './propositions/panneauxLc/index';
import reseauxTempo from './propositions/reseauxTempo/index';
import reseauxLc from './propositions/reseauxLc/index';
import panneauxNumeriques from './propositions/panneauxNumeriques/index';
import reseauxNumeriques from './propositions/reseauxNumeriques/index';
import reseauxPersonnalise from './propositions/reseauxPersonnalise/index';
import filtreOpp from './composants/filtreOpp';

import mobileNavApp from './ismobile/composants/navApp';
import mobileInfoCommercial from './ismobile/composants/infoCommercial';
import mobileInfoOpp from './ismobile/composants/infoOpp';
import mobileBlocSelection from './ismobile/composants/blocSelection';
import mobilePanneauxLc from './ismobile/propositions/panneauxLc/index';
import mobileReseauxTempo from './ismobile/propositions/reseauxTempo/index';
import mobileReseauxLc from './ismobile/propositions/reseauxLc/index';
import mobilePanneauxNumeriques from './ismobile/propositions/panneauxNumeriques/index';
import mobileReseauxNumeriques from './ismobile/propositions/reseauxNumeriques/index';
import mobileReseauxPersonnalise from './ismobile/propositions/reseauxPersonnalise/index';

export default {
  name: 'App',
  data() {
    return {
      dataLoad: false,
      showContact: true,
      detailOpportunite: {},
      produitOpportunite: {},
      filterProduit: [],
      adressesProduits: [],
      client: {},
      idOpportunite: null,
      showDimension: false,
    };
  },
  components: {
    appNavApp: navApp,
    appInfoOpp: infoOpp,
    appInfoCommercial: infoCommercial,
    appBlocSelection: blocSelection,
    appCartoGeneral: cartoGeneral,
    appPanneauxLc: panneauxLc,
    appReseauxTempo: reseauxTempo,
    appReseauxLc: reseauxLc,
    appPanneauxNumeriques: panneauxNumeriques,
    appReseauxNumeriques: reseauxNumeriques,
    appReseauxPersonnalise: reseauxPersonnalise,
    appMobileNavApp: mobileNavApp,
    appMobileInfoOpp: mobileInfoOpp,
    appMobileBlocSelection: mobileBlocSelection,
    appMobileInfoCommercial: mobileInfoCommercial,
    appMobilePanneauxLc: mobilePanneauxLc,
    appMobileReseauxTempo: mobileReseauxTempo,
    appMobileReseauxLc: mobileReseauxLc,
    appMobilePanneauxNumeriques: mobilePanneauxNumeriques,
    appMobileReseauxNumeriques: mobileReseauxNumeriques,
    appMobileReseauxPersonnalise: mobileReseauxPersonnalise,
    filtreOpp,
  },
  computed: {
    dataInfoOpp() {
      return {
        nomCommercial: this.detailOpportunite.opportunite.data.client.nomCommercial,
        themeCampagne: this.detailOpportunite.opportunite.themeCampagne,
        dateCreation: this.detailOpportunite.opportunite.dateCreation,
        urlLogo: this.detailOpportunite.societe.urlLogo,
      };
    },
    adressePuceNoireClient() {
      if (this.client.nomCommercial !== undefined) {
        return {
          lat: this.client.latitude,
          lng: this.client.longitude,
        };
      }
      return '';
    },
    adressePuceNoireFaceLc() {
      if (this.adressesProduits === undefined) return '';
      try {
        const indexAdress = this.adressesProduits.findIndex(el => el.nom === 'adresseFaceLc');
        if (indexAdress !== -1) {
          return {
            lat: this.adressesProduits[indexAdress].lat,
            lng: this.adressesProduits[indexAdress].lng,
          };
        }
        return '';
      } catch (error) {
        return '';
      }
    },
    adressePuceNoireReseauxLc() {
      if (this.adressesProduits === undefined) return '';
      try {
        const indexAdress = this.adressesProduits.findIndex(el => el.nom === 'adresseReseauxLc');
        if (indexAdress !== -1) {
          return {
            lat: this.adressesProduits[indexAdress].lat,
            lng: this.adressesProduits[indexAdress].lng,
          };
        }
        return '';
      } catch (error) {
        return '';
      }
    },
    adressePuceNoireReseauxTempo() {
      if (this.adressesProduits === undefined) return '';
      try {
        const indexAdress = this.adressesProduits.findIndex(el => el.nom === 'adresseReseauxTempo');
        if (indexAdress !== -1) {
          return {
            lat: this.adressesProduits[indexAdress].lat,
            lng: this.adressesProduits[indexAdress].lng,
          };
        }
        return '';
      } catch (error) {
        return '';
      }
    },
    adressePuceNoireReseauxNumeriques() {
      if (this.adressesProduits === undefined) return '';
      try {
        const indexAdress = this.adressesProduits.findIndex(el => el.nom === 'adresseReseauxNumeriques');
        if (indexAdress !== -1) {
          return {
            lat: this.adressesProduits[indexAdress].lat,
            lng: this.adressesProduits[indexAdress].lng,
          };
        }
        return '';
      } catch (error) {
        return '';
      }
    },
    adressePuceNoireVenteNumerique() {
      try {
        const indexAdress = this.adressesProduits.findIndex(el => el.nom === 'adresseVenteNumerique');
        if (indexAdress !== -1) {
          return {
            lat: this.adressesProduits[indexAdress].lat,
            lng: this.adressesProduits[indexAdress].lng,
          };
        }
        return '';
      } catch (error) {
        return '';
      }
    },
    dataInfoCommercial() {
      return {
        contact: this.detailOpportunite.commercial,
        nomCommercial: this.detailOpportunite.commercial.agence ?
          this.detailOpportunite.commercial.agence.libelleSociete : '',
      };
    },
    commercialName() {
      const toReturn = this.detailOpportunite.commercial && this.detailOpportunite.commercial.prenom ? this.detailOpportunite.commercial.prenom + ',<br>' : '';
      return toReturn;
    },
    clientName() {
      return {
        societe: this.detailOpportunite.opportunite
        && this.detailOpportunite.opportunite.data.client.nomCommercial
          ? ' ' + this.detailOpportunite.opportunite.data.client.nomCommercial : null,
        nom: this.detailOpportunite.opportunite
        && this.detailOpportunite.opportunite.data.contact ? ' '
          + this.detailOpportunite.opportunite.data.contact.prenom + ' '
          + this.detailOpportunite.opportunite.data.contact.nom : '',
      };
    },
    themeCampagne() {
      return this.detailOpportunite.opportunite
      && this.detailOpportunite.opportunite.themeCampagne
        ? ' « <strong>' + this.detailOpportunite.opportunite.themeCampagne + ' »</strong>' : '';
    },
    menu() {
      return {
        panneauxLc: this.produitOpportunitepanneauxLc.filter(d =>
          !d.extensionOpportunite.reseauPersoGuid).length,
        reseauxTempo: this.produitOpportunitereseauxTempo.filter(d =>
          !d.extensionOpportunite.reseauPersoGuid).length,
        reseauxLc: this.produitOpportunitereseauxLc.filter(d =>
          !d.extensionOpportunite.reseauPersoGuid).length,
        panneauxNumeriques: this.produitOpportunitepanneauxNumeriques.filter(d =>
          !d.extensionOpportunite.reseauPersoGuid).length,
        reseauxNumeriques: this.produitOpportunitereseauxNumeriques.filter(d =>
          !d.extensionOpportunite.reseauPersoGuid).length,
        reseauxPersonnalise: this.produitOpportunitereseauxPersonnalise.length,
      };
    },
    isMobile() {
      return getMobile();
    },
    showGenralCarto() {
      let length = 0;
      const produits = cloneDeep(this.produitOpportunite);
      length += produits.panneauxLc
        .filter(el => !el.extensionOpportunite.reseauPersoGuid).length > 0 ? 1 : 0;
      length += produits.panneauxNumeriques
        .filter(el => !el.extensionOpportunite.reseauPersoGuid).length > 0 ? 1 : 0;
      delete produits.panneauxLc;
      delete produits.panneauxNumeriques;
      produits.reseauxPersonnalise.forEach(el => {
        el.extensionOpportunite = {
          reseauPersoGuid: null,
        };
      });
      length += Object
        .values(produits)
        .filter(el => el.length > 0)
        .flat()
        .filter(el => !el.extensionOpportunite.reseauPersoGuid)
        .length;
      return length > 1;
    },
  },
  methods: {
    async load() {
      this.dataLoad = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.idOpportunite = this.$route.params.id;
        this.detailOpportunite = await getOpportunite(this.$route.params.id);
        this.adressesProduits = this.detailOpportunite.opportunite.data.adressesProduits;
        this.client = this.detailOpportunite.opportunite.data.client;
        this.produitOpportunite = this.detailOpportunite.opportunite.data.produits;
        this.showDimension = this.detailOpportunite.showDimension;
        this.produitOpportunite.panneauxLc.forEach(panneau => {
          if (panneau.extensionOpportunite.urlPhoto !== null) {
            panneau.extensionOpportunite.urlPhoto = panneau.extensionOpportunite.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
          }
        });
        this.produitOpportunite.panneauxNumeriques.forEach(panneau => {
          if (panneau.urlPhoto !== null) {
            panneau.urlPhoto = panneau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
          }
        });
        this.produitOpportunite.reseauxLc.forEach(reseau => {
          if (reseau.urlPhoto !== null) {
            reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
          }
        });
        this.produitOpportunite.reseauxTempo.forEach(reseau => {
          if (reseau.urlPhoto !== null) {
            reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
          }
        });
        this.produitOpportunite.reseauxNumeriques.forEach(reseau => {
          if (reseau.urlPhoto !== null) {
            reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
          }
        });
        this.produitOpportunite.reseauxPersonnalise.forEach(reseau => {
          if (reseau.urlPhoto !== null) {
            reseau.urlPhoto = reseau.urlPhoto.replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
          }
        });
        loadingComponent.close();
        this.dataLoad = true;
      } catch (e) {
        loadingComponent.close();
        gestionErreur('Erreur serveur');
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped >

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/App.vue